import React from "react";
import { Box, Paper } from "@mui/material";

export interface AppPageProps {
  children: React.ReactNode;
  /** Optional header slot rendered above the inner Paper. Pair with PageHeader. */
  header?: React.ReactNode;
  /** Skip the inner Paper if a page already manages its own card surface. */
  disablePaper?: boolean;
}

/**
 * Standard premium page wrapper for the DCC navy + gold system.
 *
 * Usage:
 *   <AppPage header={<PageHeader title="Orders" />}>
 *     ...page content...
 *   </AppPage>
 */
export default function AppPage({ children, header, disablePaper }: AppPageProps) {
  return (
    <Box sx={{ p: 3, background: "#F8FAFC", minHeight: "100vh" }}>
      {header}
      {disablePaper ? (
        <Box sx={{ mt: header ? 2 : 0 }}>{children}</Box>
      ) : (
        <Paper
          elevation={0}
          sx={{
            mt: header ? 2 : 0,
            p: 2.5,
            borderRadius: "16px",
            background: "#fff",
            boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
          }}
        >
          {children}
        </Paper>
      )}
    </Box>
  );
}
